import React, { useState } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';

import { withErrorBoundary } from 'components/shared/Error/Boundary';
import Loader from 'components/shared/Loader/Loader';
import ToggleSwitch from 'components/shared/ToggleSwitch/ToggleSwitch';

import { checkActive, switchItems, switchTabs } from './helper';

const AdminIntelligence = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [count, setCount] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  return (
    <div className="flex h-full flex-col">
      {isLoading && (
        <div className="flex flex-row gap-2">
          <Loader outlined color="primary" />
          <div>Loading...</div>
        </div>
      )}
      <Outlet
        context={{
          setLoading: setIsLoading,
          setCount,
          switchTabs,
          switchItems,
          toggleSwitch: (
            <ToggleSwitch
              items={switchItems}
              onClick={(item) => switchTabs(item, navigate)}
              active={checkActive(location)?.value}
              count={count}
            />
          )
        }}
      />
    </div>
  );
};

export default withErrorBoundary(AdminIntelligence);
